export default __webpack_public_path__ + "static/media/dc2e8e6fea81c77b8752655359e1923d.svg";